import { render, staticRenderFns } from "./DiscountsAdd.vue?vue&type=template&id=62be78b8"
import script from "./DiscountsAdd.vue?vue&type=script&lang=js"
export * from "./DiscountsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports